module.exports = __webpack_public_path__ + "static/img/swift.3de167c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swift.png
// module id = 1+8J
// module chunks = 0